<template>
<svg viewBox="0 0 1116 582" xmlns="http://www.w3.org/2000/svg">
  <defs>
  </defs>
  <path id="item-line0" class="cls-1 fix-svg-origin animated zoomIn" d="M832 151s-47.28-48.12-130.42-31.38c0 0-123.47 22.1-166.28-27.12H532c-48.9 46.88-166.28 27.12-166.28 27.12C282.61 102.88 235.33 151 235.33 151" fill="none" stroke="#ffe300" stroke-miterlimit="10"/>
  <g id="item0">
    <path fill="none" stroke="#beeb7b" stroke-miterlimit="10" d="M399.66 40.75h268v51h-268z"/>
    <text x="422.75" y="72.75" fill="#beeb7b" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond,Helvetica LT Std" font-size="22" font-weight="700">
      Métodos determinísticos
    </text>
  </g>
  <g id="boton2" class="fix-svg-origin hvr hvr-clr animated zoomIn" v-ripple @click="$set(vistos,1,true)">
    <path class="cls-5" stroke="#fff" stroke-miterlimit="10" d="M761.5 153.5h141v44h-141z"/>
    <text class="cls-4" x="778.22" y="182" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond, 'Helvetica LT Std'" font-size="22" font-weight="700">
      Debilidades
    </text>
  </g>
  <path id="item-line1" v-if="vistos[0]" class="cls-1 fix-svg-origin animated zoomIn" fill="none" stroke="#ffe300" stroke-miterlimit="10" d="M47.75 455V214.5H232.5v-17"/>
  <text id="texto1" v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="71" y="257.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    Describe un caso físico específico.
  </text>
  <g id="item1" v-if="vistos[0]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="48.38" cy="250.11" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.5 251.2l6 7.41 11-15"/>
  </g>
  <text id="texto2" v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="71" y="313.31" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    Es un método directo, fácil de explicar <tspan x="71" y="338.31">y eficiente en mano de obra.</tspan>
  </text>
  <g id="item2" v-if="vistos[0]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="48.38" cy="306.41" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.5 307.5l6 7.41 11-15"/>
  </g>
  <text id="texto3" v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="71" y="389.31" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    Usado históricamente con resultados <tspan x="71" y="414.31">confiables y repetitivos.</tspan>
  </text>
  <g id="item3" v-if="vistos[0]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="48.38" cy="382.41" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.5 383.5l6 7.41 11-15"/>
  </g>
  <text id="texto4"  v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="71" y="460.31" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    Es el método preferido por inversionistas <tspan x="71" y="485.31">y accionistas, ampliamente utilizado para</tspan><tspan x="71" y="510.31">reporte de reservas probadas a entes</tspan><tspan x="71" y="535.31">regulatorios.</tspan>
  </text>
  <g id="item4" v-if="vistos[0]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="48.38" cy="453.41" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.5 454.5l6 7.41 11-15"/>
  </g>
  <path id="item-line2" v-if="vistos[1]" class="cls-1 fix-svg-origin animated zoomIn" fill="none" stroke="#ffe300" stroke-miterlimit="10" d="M646.75 331V214.5H831.5v-17"/>
  <text id="texto5" v-if="vistos[1]" class="cls-6 animated fadeInLeft dura-2" x="671" y="257.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    No cuantifica la probabilidad de los escenarios <tspan x="671" y="282.61">de baja, media y alta incertidumbre.</tspan>
  </text>
  <text id="texto6" v-if="vistos[1]" class="cls-6 animated fadeInLeft dura-2" x="671" y="336.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
    Se requiere conocimiento para analizar los <tspan x="671" y="361.61">escenarios de baja y alta incertidumbre.</tspan>
  </text>
  <g id="item5" v-if="vistos[1]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="647.38" cy="250.11" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M639.5 251.2l6 7.41 11-15"/>
  </g>
  <g id="item6" v-if="vistos[1]" class="animated zoomIn dura-1">
    <circle class="cls-7" cx="647.38" cy="330.41" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
    <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M639.5 331.5l6 7.41 11-15"/>
  </g>
  <g id="boton1" class="fix-svg-origin hvr hvr-clr animated zoomIn" @click="$set(vistos,0,true)">
    <path class="cls-5" stroke="#fff" stroke-miterlimit="10" d="M163.5 153.5h141v44h-141z"/>
    <text class="cls-4" x="187.56" y="182" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond, 'Helvetica LT Std'" font-size="22" font-weight="700">
      Fortalezas
    </text>
  </g>
</svg>
</template>
<script>
export default {
  data() {
    return {
      vistos: [false, false]
    }
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$emit('finished')
      }
    }
  }
}
</script>

<style scoped>
  #item-line0{
    transform-origin: 500px 100px;
  }
  #item-line1{
    transform-origin: 260px 220px;
  }
  #item-line2{
    transform-origin: 800px 220px;
  }
  #item5, #item6 {
    transform-origin: 650px 0;
  }
  .cls-1,.cls-8{fill:none; transition: all 250ms;}.cls-5{fill: transparent}.cls-1,.cls-7{stroke:#ffe300}.cls-1,.cls-5,.cls-7{stroke-miterlimit:10}.cls-4,.cls-6{font-size:22px}.cls-4{font-family:helveticaNeueCn, HelveticaLTStd-BoldCond,Helvetica LT Std;font-weight:700}.cls-4,.cls-6{fill:#fff}.cls-5{stroke:#fff}.cls-6{font-family:helveticaNeueCn, HelveticaLTStd-Cond,Helvetica LT Std}.cls-7{fill:#121a26}.cls-8{stroke:#5b9b00;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}
  .hvr-clr:hover .cls-5{
    fill: rgba(255,255,255,0.1) !important;
  }
</style>